module.exports = __webpack_public_path__ + "static/media/2025_wolke_hoch.caf43598.png";